module.exports = __webpack_public_path__ + "img/banner3.47676c76.png";